export async function hashedCustomerId(customerId?: string) {
  if (!customerId) {
    return '';
  }
  const utf8 = new TextEncoder().encode(customerId);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
  const base64Hash = btoa(String.fromCharCode(...new Uint8Array(hashBuffer)));
  return base64Hash;
}
